export default __webpack_public_path__ + "static/media/CNo.45-2.20d2fa4c.jpg";